<template>
  <b-card header="Location Edit Form">
    <b-form :id="'locationEditForm' + passedLocation.id" v-on:submit.prevent>
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>Name</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            type="text"
            id="name"
            v-model="formData.name"
            placeholder="name"
            :value="passedLocation.name"
            @keyup.enter="submitData(passedLocation.id, $event.target)"
          ></b-form-input>
        </b-input-group>
      </b-form-group>
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>Description</b-input-group-text>
          </b-input-group-prepend>
          <!-- <b-form-textarea :rows="6" :max-rows="6" id="description" :value="passedLocation.description"></b-form-textarea> -->
          <textarea id="description" class="form-control" v-model="passedLocation.description" />
        </b-input-group>
      </b-form-group>
      <div class="form-group form-actions">
        <b-button
          @click="submitData(passedLocation.id, $event.target)"
          type="button"
          size="sm"
          variant="primary"
        >Save</b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
let qs = require("qs");
const constants = require("./shared/constants");
const BASE = constants.NEWPORT_CONST.API_URL;
const API = BASE + "/api/locations/edit";
//const API_LIST = BASE + '/api/locations/simpleList'

function postdata(url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    method: "POST"
  }).then(res => res.json());
}

// async function getData () {
//   let parameters = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     accessToken: localStorage.getItem('token')
//   }
//   let res = await postdata(API_LIST, parameters)
//   return res.locations
// }

export default {
  name: "location-form",
  props: ["passedLocation", "editModalId"],
  data() {
    return {
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem("token"),
        locationId: "",
        name: "",
        description: ""
      }
    };
  },
  methods: {
    submitData(locationId, button) {
      // event.preventDefault();
      const thisForm = document.getElementById("locationEditForm" + locationId); // should be unique, maybe ID of location should be added
      this.formData.locationId = locationId;
      this.formData.name = thisForm.name.value;
      this.formData.description = thisForm.description.value;

      let localLocationsList = localStorage.getItem("localLocationsList");

      if (localLocationsList === null || localLocationsList === "undefined") {
        localStorage.clear();
        this.$router.push("/pages/login");
      } else {
        postdata(API, this.formData)
          .then(data => {
            // list dari localstorage
            localLocationsList = JSON.parse(localLocationsList);
            // update data yang sudah di lakukan
            for (let i in localLocationsList) {
              let loopLocation = localLocationsList[i]
              if (loopLocation.id == locationId) {
                localLocationsList[i] = data.location
                
              }
            }

            if(data.status.errCode == 200) {

              let localLockList = localStorage.getItem('localLocksList')
              
              localLockList = JSON.parse(localLockList)

              let indexes = localLockList.reduce((arr, lock, i) => ((lock.locationId == locationId) && arr.push(i), arr),[])
              for(let i in indexes) {
                let li = indexes[i]
                localLockList[li].location = data.location
              }
              localStorage.setItem('localLocksList', JSON.stringify(localLockList))
              

              // let locksForLocation = localStorage.getItem('locksForLocation')

              // locksForLocation = JSON.parse(locksForLocation)

              // let indexLock = locksForLocation.reduce((arr, lockk, i) => ((lockk.locationId == locationId) && arr.push(i), arr), [])
              // for(let k in indexLock) {
              //   let indexx = indexLock[k]
              //   locksForLocation[k].location = data.location
              // }
              // localStorage.setItem('locksForLocation', JSON.stringify(locksForLocation))

            }

            let favLocation = localStorage.getItem("favLocation");

//            this.$root.$emit("locations", localLocationsList);
            this.$root.$emit('editLocation', data.location);
            
            this.$root.$emit("bv::hide::modal", this.editModalId, button);
        
          })
          .catch(error => {
            console.error(error);
          });
      }
    },

    onReset(evt) {
      evt.preventDefault();
      this.formData.lockId = "";
      this.formData.managerId = "";
      this.formData.addDate = "";
      this.formData.startDate = "";
      this.formData.endDate = constants.NEWPORT_CONST.END_DATE;
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    sortLocation(favLocation, list, origin) {
      origin.sort((a, b) => a.name.localeCompare(b.name));

      let theRest = origin;
      var index = list.findIndex(x => {
        return x.id === favLocation;
      });
      let fav = list[index];
      theRest.splice(index, 1);
      list.unshift(fav);
      return theRest;
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          alert("From Submitted!");
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/base/LocationForm.vue